<!-- 新建开票 -->
<template>
  <div class="InvoicesAddRX">
    <el-button v-if="keyType==1 || keyType==2" class="glo_bgcMainColor saveBtn" @click="createInvoice">保存</el-button>
    <el-button v-if=" keyType==4 || keyType==3" class="glo_bgcMainColor saveBtn" @click="createInvoice">开票确认</el-button>
    <!-- <el-button class="glo_bgcMainColor saveBtn" @click="resetFields">
      重置
    </el-button>-->
    <div class="formPanel" ref="formPanel">
      <el-form :model="baseInForm" ref="baseInForm" label-width="100px" :rules="baseInFormRules" class="glo_formBox">
        <el-form-item label="对账单号:">
          <el-input v-model="baseInForm.documentNumber" placeholder="请输入" @focus="choiceOrder">
            <el-button slot="append" @click="choiceOrder" icon="el-icon-search" />
          </el-input>
        </el-form-item>
        <el-form-item label="对账金额:">
          <el-input v-model="baseInForm.amount" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label="未开票金额:">
          <el-input v-model="baseInForm.noInvoiceAmount" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label="已开票金额:">
          <el-input v-model="baseInForm.hadInvoiceAmount" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item style="width: 560px" label="结算对象:">
          <div class="multipleSelect">
            <el-select filterable clearable v-model="baseInForm.objectStatus" placeholder="请选择" @change="changeObjestStatus">
              <el-option v-for="(item, index) in objectStatusList" :key="index" :label="item.val" :value="item.key"></el-option>
            </el-select>
            <el-select
              filterable
              clearable
              v-model="baseInForm.objectName"
              placeholder="请选择"
              :allow-create="baseInForm.objectStatus == 'other'"
              remote
              :remote-method="getObjectUserDownListYf"
              @change="changeobjectName"
            >
              <el-option v-for="(item, index) in CustomerListsYF" :key="index" :label="item.name" :value="item.name"></el-option>
            </el-select>
          </div>
        </el-form-item>

        <el-form-item label="发票类型:">
          <el-select v-model="baseInForm.invoiceTypeConfDictId" placeholder="请选择">
            <el-option v-for="(item, index) in invoiceTypes" :key="index" :label="item.val" :value="item.confDictId" />
          </el-select>
        </el-form-item>
        <el-form-item label="申请日期:" prop="applyTime">
          <el-date-picker type="datetime" placeholder="选择日期" value-format="yyyy-MM-dd HH:mm:ss" v-model="baseInForm.applyTime" style="width: 100%" />
        </el-form-item>
        <el-form-item label="发票种类:" prop="invoiceProjectConfDictId">
          <el-select v-model="baseInForm.invoiceProjectConfDictId" placeholder="请选择">
            <el-option v-for="(item, index) in invoice_type_list" :key="index" :label="item.val" :value="item.confDictId" />
          </el-select>
        </el-form-item>
        <el-form-item label="发票号:">
          <el-input v-model="baseInForm.invoiceNumber" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label="开票日期:">
          <el-date-picker type="datetime" placeholder="选择日期" value-format="yyyy-MM-dd HH:mm:ss" v-model="baseInForm.openInvoiceDate" style="width: 100%" />
        </el-form-item>
      </el-form>
    </div>
    <div class="formPanel">
      <el-form label-width="100px" class="glo_formBox">
        <el-form-item label="购买方名称:">
          <el-input v-model="headerInfo.header" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="纳税人识别号:">
          <el-input v-model="headerInfo.identifyNumber" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item class="textArea" style="width: 100%" label="地址、电话:">
          <el-input type="textarea" rows="2" v-model="headerInfo.addrPhone" />
        </el-form-item>
        <el-form-item class="textArea" style="width: 100%" label="开户行及账号:">
          <el-input type="textarea" rows="2" v-model="headerInfo.bank" />
        </el-form-item>
        <el-form-item label="货物信息:">
          <el-input v-model="headerInfo.goodsInfo" placeholder="请输入" clearable />
        </el-form-item>
      </el-form>
    </div>
    <div>
      <el-table :data="projectList" border style="width: 1400px" show-summary ref="mytable1">
        <el-table-column fixed="left" align="center" label="序号" type="index" width="60"></el-table-column>
        <el-table-column prop="goodsNumber" label="*开票项目">
          <template slot-scope="scope">
            <el-select @change="onInputHW(scope.$index)" :disabled="disabledSee" v-model="projectList[scope.$index].invoiceProjectConfDictId" filterable clearable placeholder="请选择">
              <el-option v-for="(item2, index2c) in invoiceProjects" :key="index2c" :label="item2.val" :value="item2.confDictId"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="goodsName" label="规格型号">
          <template slot-scope="scope">
            <el-input @input="onInputHW(scope.$index)" :disabled="disabledSee" type="text" v-model="projectList[scope.$index].specModel" placeholder="请输入" filterable></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="packageCout" label="单位" sortable>
          <template slot-scope="scope">
            <el-input @input="onInputHW(scope.$index)" :disabled="disabledSee" type="text" v-model="projectList[scope.$index].unit" placeholder="请输入"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="grossWeight" label="数量" sortable>
          <template slot-scope="scope">
            <el-input @input="onInputHW(scope.$index)" :disabled="disabledSee" type="number" v-model="projectList[scope.$index].packageCount" placeholder="请输入"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="netWeight" label="单价" sortable>
          <template slot-scope="scope">
            <el-input @input="onInputHW(scope.$index)" :disabled="disabledSee" type="number" v-model="projectList[scope.$index].unitPrice" placeholder="请输入"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="volume" label="金额" sortable width="100">
          <template slot-scope="scope">
            <el-input @input="onInputHW(scope.$index)" :disabled="disabledSee" type="number" v-model="projectList[scope.$index].amount" placeholder="请输入"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="volumeWeight" label="税率(%)" sortable width="120">
          <template slot-scope="scope">
            <el-input @input="onInputHW(scope.$index)" :disabled="disabledSee" type="number" v-model="projectList[scope.$index].taxRate" placeholder="请输入"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="weightVolume" label="税额" sortable width="120">
          <template slot-scope="scope">
            <el-input @input="onInputHW(scope.$index)" :disabled="disabledSee" type="number" v-model="projectList[scope.$index].taxAmount" placeholder="请输入"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="billingWeight" label="*价格合税" sortable width="120">
          <template slot-scope="scope">
            <el-input @input="onInputHW(scope.$index)" :disabled="disabledSee" type="number" v-model="projectList[scope.$index].taxPrice" placeholder="请输入"></el-input>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" v-if="!disabledSee">
          <template slot-scope="scope">
            <div class="iconList">
              <i v-if="scope.$index==0" class="el-icon-circle-plus iconSize" @click="AddGoods(scope.$index)"></i>
              <el-popconfirm v-else title="确定删除该行信息吗" @confirm="delGoods(scope.$index)">
                <i slot="reference" class="el-icon-remove iconSize"></i>
              </el-popconfirm>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="formPanel">
      <el-form label-width="100px" class="glo_formBox">
        <el-form-item label="车牌号:">
          <el-input v-model="baseInForm.carNumber" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item class="textArea" style="width: 100%" label="内部备注:">
          <el-input type="textarea" rows="2" v-model="baseInForm.remark" />
        </el-form-item>
        <el-form-item class="textArea" style="width: 100%" label="客户备注:">
          <el-input type="textarea" rows="2" v-model="baseInForm.externalRemarks" />
        </el-form-item>
      </el-form>
    </div>
    <div class="formPanel">
      <el-form label-width="100px" class="glo_formBox">
        <el-form-item label="销售方名称:">
          <el-input v-model="saleHeaderInfo.header" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="纳税人识别号:">
          <el-input v-model="saleHeaderInfo.identifyNumber" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item class="textArea" style="width: 100%" label="地址、电话:">
          <el-input type="textarea" rows="2" v-model="saleHeaderInfo.addrPhone" />
        </el-form-item>
        <el-form-item class="textArea" style="width: 100%" label="开户行及账号:">
          <el-input type="textarea" rows="2" v-model="saleHeaderInfo.bank" />
        </el-form-item>
      </el-form>
    </div>
    <!-- 选择对账单号弹窗 -->
    <my-dialog
      :diaWidth="diaWidth"
      :dialogTitle="dialogTitle"
      :isShowDialog="isShowDialog"
      :dialogFooter="false"
      @handleCloseDia="handleCloseDia"
      @diaCancelBtn="diaCancelBtn"
      @diaConfirmBtn="diaConfirmBtn"
    >
      <table-plug
        :tableConfig="tableConfig_dia"
        :defaulthead="myTableHeard_dia"
        :showSumm="true"
        :checkbox="false"
        :totals="totalArr_dia"
        @rowCallback="rowCallback"
        @selectChange="handleSelectionChange_dia"
      />
      <!-- 分页 -->
      <paging :pageNum="pageStart_dia" :total="pageCount_dia" :size="pageTotal_dia" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange" />
    </my-dialog>
  </div>
</template>
  <script >
import MyDialog from "@/components/Dialog.vue";
import paging from "@/components/pagings.vue";
import TablePlug from "@/components/Modules/TablePlug.vue";

export default {
  inject: ["reload"],
  components: {
    TablePlug,
    MyDialog,
    paging,
  },
  data() {
    return {
      invoiceTypeConfDictId: "",
      carNumberList1: [], //车牌号码
      disabledSee: false,
      projectList: [
        {
          operationType: "ADD",
        },
      ],
      objectStatusList: [],
      CustomerListsYF: [],
      baseInForm: {
        documentStatus: "finance_account_statement_v3:document_status",
        documentNumber: "",
        amount: "",
        noInvoiceAmount: "",
        hadInvoiceAmount: "",
        objectStatus: "",
        objectStatusConfDictId: "",
        objectName: "",
        objectNumber: "",
        invoiceTypeConfDictId: "",
        invoiceProject: "", //name
        invoiceProjectConfDictId: "",
        applyTime: this.$TOOLS.getCurrentTime(),
      },
      baseInFormRules: {
        applyTime: [{ required: true, message: "请选择", trigger: "change" }],
        invoiceProjectConfDictId: [
          { required: true, message: "请选择", trigger: "change" },
        ],
      },
      headerInfo: {
        addrPhone: "",
        bank: "",
        goodsInfo: "",
        header: "",
        identifyNumber: "",
      },
      saleHeaderInfo: {
        addrPhone: "",
        bank: "",
        goodsInfo: "",
        header: "",
        identifyNumber: "",
      },
      invoiceProjects: [],
      invoiceTypes: [],
      diaWidth: "60%",
      dialogTitle: "选择对账单号",
      isShowDialog: false,
      tableConfig_dia: {
        tableHeigth: "400px",
        tableData: [{}],
      },
      myTableHeard_dia: [
        {
          name: "操作",
          field: "edit",
          width: 120,
          Buttons: [
            {
              method: "checkdata",
              methodName: "选择",
            },
          ],
        },
        {
          name: "对账单号",
          field: "number",
          width: "120", // default：120
          sort: 3,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计 default：false
          isSort: true, //表格设置里面是否可以排序 default：false
        },
        {
          name: "应收合计",
          field: "financeInAmount",
          sort: 4,
          isShow: true,
          isTotal: true,
          isSort: true,
        },
        {
          name: "应付合计",
          field: "financeOutAmount",
          sort: 5,
          isShow: true,
          isTotal: true,
          isSort: true,
        },
        {
          name: "结算金额",
          field: "settlementAmount",
          width: "120",
          sort: 5,
          isShow: true,
          isTotal: true,
          isSort: true,
        },
        {
          name: "核准金额",
          field: "approvalAmount",
          width: "120",
          sort: 6,
          isShow: true,
          isTotal: true,
          isSort: true,
        },
        {
          name: "已开票金额",
          field: "invoiceAmount",
          sort: 1,
          isShow: true,
          isTotal: true,
          isSort: true,
        },
        {
          name: "未开票金额",
          field: "noInvoiceAmount",
          sort: 1,
          isShow: true,
          isTotal: true,
          isSort: true,
        },
        {
          name: "已核销金额",
          field: "writeoffAmount",
          width: "120",
          sort: 18,
          isShow: true,
          isTotal: true,
          isSort: true,
        },
        {
          name: "未核销金额",
          field: "noWriteoffAmount",
          sort: 19,
          isShow: true,
          isTotal: true,
          isSort: true,
        },
        {
          name: "结算对象类型",
          field: "objectStatus",
          width: "140",
          sort: 1,
          isShow: true,
        },
        {
          name: "结算对象",
          field: "objectName",
          sort: 1,
          isShow: true,
        },
        {
          name: "核销状态",
          field: "writeoffStatusShow",
          sort: 2,
          isShow: true,
        },
        {
          name: "客户对账状态",
          field: "customerReconciliationStatusShow",
          width: 140,
          sort: 2,
          isShow: true,
        },

        {
          name: "业务网点",
          field: "businessDeptName",
          sort: 1,
          isShow: true,
        },
        {
          name: "对账网点",
          field: "reconciliationDeptName",
          width: "120",
          sort: 1,
          isShow: true,
        },
        {
          name: "对账单备注",
          field: "reconciliationRemark",
          width: "160",
          sort: 1,
          isShow: true,
        },

        {
          name: "创建人",
          field: "createUserName",
          sort: 120,
          isShow: true,
        },

        {
          name: "最新核销人",
          field: "writeoffUserName",
          sort: 6,
          isShow: true,
        },

        {
          name: "最新核销时间",
          field: "writeoffTime",
          width: "140",
          sort: 1,
        },
        {
          name: "最新资金账号",
          field: "zjAccount",
          width: "140",
          sort: 1,
        },
        {
          name: "最新核销备注",
          field: "writeoffComment",
          width: "140",
          sort: 1,
          isShow: true,
        },
      ],
      totalArr_dia: [],
      pageStart_dia: 1,
      pageTotal_dia: 20,
      pageCount_dia: 0,

      pageStart: 1,
      pageTotal: this.$COMMON.pageTotals,
      pageCount: 0,
      selectTableData: [],
      invoice_type_list: [],
      invoiceId: "",
      keyType: "",
      projectIds: [],
      taxRate: "",
    };
  },
  computed: {},
  activated() {
    this.curInit();
  },
  created() {
    this.GetDictionaries("invoice_project");
    this.GetDictionaries("invoice_type");
    this.GetDictionaries("object_status");
  },
  watch: {},
  methods: {
    async curInit() {
      // 每次进页面都会触发的写这里
      await this.GetDictionaries("fa_piao_type");
      let { invoiceId, keyType, number } = this.$route.query;
      this.baseInForm = {
        documentStatus: "finance_account_statement_v3:document_status",
        documentNumber: "",
        amount: "",
        noInvoiceAmount: "",
        hadInvoiceAmount: "",
        objectStatus: "",
        objectStatusConfDictId: "",
        objectName: "",
        objectNumber: "",
        invoiceTypeConfDictId: this.invoiceTypeConfDictId,
        invoiceProject: "", //name
        invoiceProjectConfDictId: "",
        applyTime: this.$TOOLS.getCurrentTime(),
      };
      this.headerInfo = {
        addrPhone: "",
        bank: "",
        goodsInfo: "",
        header: "",
        identifyNumber: "",
      };
      this.saleHeaderInfo = {
        addrPhone: "",
        bank: "",
        goodsInfo: "",
        header: "",
        identifyNumber: "",
      };
      await this.runPageReportDetailsApi();
      this.projectList = [
        {
          operationType: "ADD",
          taxRate: this.taxRate,
        },
      ];
      if (keyType) {
        this.keyType = keyType;
      }
      if (number) {
        this.GetStatementList(number);
      }
      if (invoiceId) {
        this.invoiceId = invoiceId;
        this.invoicegetInvoiceDetail(invoiceId);
      }
    },
    runPageReportDetailsApi() {
      return this.$API
        .runPageReportDetails({
          conditionReqs: [],
          number: "base_data_info",
        })
        .then((res) => {
          if (res.data.status === "success") {
            let lists = res.data.result.datas || [];
            let taxRate = "";
            let header = "";
            let identifyNumber = "";
            let addrPhone = "";
            let bank = "";
            lists.forEach((element) => {
              switch (element.key) {
                case "invoice_rate":
                  taxRate = element.val || "";
                  break;
                case "header":
                  header = element.val || "";
                  break;
                case "identify_number":
                  identifyNumber = element.val || "";
                  break;
                case "addr_phone":
                  addrPhone = element.val || "";
                  break;
                case "bank":
                  bank = element.val || "";
                  break;
                default:
                  break;
              }
            });
            this.taxRate = taxRate;
            this.saleHeaderInfo = {
              header,
              identifyNumber,
              addrPhone,
              bank,
              goodsInfo: "",
            };
          } else {
            this_.$message.error(`${res.data.message}---综合查询列表`);
          }
        });
    },
    invoicegetInvoiceDetail(invoiceId) {
      this.$API
        .invoicegetInvoiceDetail({
          invoiceId,
        })
        .then((res) => {
          if (res.data.status === "success") {
            let datas = res.data.result;
            let { projectList, saleHeaderInfo, headerInfo, baseInfo } = datas;
            this.projectIds = [];
            projectList.forEach((element) => {
              this.projectIds.push(element.projectId);
              element.taxRate = this.taxRate;
              element.operationType = "UNCHANGED";
              element.invoiceProjectConfDictId =
                (element.invoiceProjectConfDictId &&
                  String(element.invoiceProjectConfDictId)) ||
                "";
            });
            this.projectList = projectList || [
              {
                operationType: "ADD",
                taxRate: this.taxRate,
              },
            ];
            this.saleHeaderInfo = saleHeaderInfo || {
              addrPhone: "",
              bank: "",
              goodsInfo: "",
              header: "",
              identifyNumber: "",
            };
            this.headerInfo = headerInfo || {
              addrPhone: "",
              bank: "",
              goodsInfo: "",
              header: "",
              identifyNumber: "",
            };
            baseInfo.objectStatusConfDictId =
              (baseInfo.objectStatusConfDictId &&
                String(baseInfo.objectStatusConfDictId)) ||
              "";
            baseInfo.invoiceTypeConfDictId =
              (baseInfo.invoiceTypeConfDictId &&
                String(baseInfo.invoiceTypeConfDictId)) ||
              this.invoiceTypeConfDictId;
            baseInfo.invoiceProjectConfDictId =
              (baseInfo.invoiceProjectConfDictId &&
                String(baseInfo.invoiceProjectConfDictId)) ||
              "";
            this.baseInForm = baseInfo || {
              documentStatus: "finance_account_statement_v3:document_status",
              documentNumber: "",
              amount: "",
              noInvoiceAmount: "",
              hadInvoiceAmount: "",
              objectStatus: "",
              objectStatusConfDictId: "",
              objectName: "",
              objectNumber: "",
              invoiceTypeConfDictId: this.invoiceTypeConfDictId,
              invoiceProject: "", //name
              invoiceProjectConfDictId: "",
            };
            this.baseInForm.invoiceNumber = "";
          }
        });
    },
    //货物信息 添加一行货物信息
    AddGoods(idx) {
      let objs = {
        operationType: "ADD",
        taxRate: this.taxRate,
      };
      this.projectList.push(objs);
    },
    //货物信息 删除一行货物信息
    delGoods(idx) {
      this.projectList.splice(idx, 1);
    },
    onInputHW(index) {
      let { projectId } = this.projectList[index];
      if (projectId && this.projectIds.includes(projectId)) {
        this.projectList[index].operationType = "UPDATE";
      }
    },
    // 选择结算对象类型
    changeObjestStatus(e) {
      this.baseInForm.objectName = "";
      this.baseInForm.objectNumber = "";
      this.baseInForm.objectStatusConfDictId = "";
      if (e) {
        this.objectStatusList.forEach((item) => {
          if (item.key == e) {
            this.baseInForm.objectStatusConfDictId = item.confDictId;
          }
        });
        this.getObjectUserDownListYf();
      }
    },
    // (应付弹窗)根据对象类型获取对象的下拉列表
    getObjectUserDownListYf(name) {
      this.$API
        .wtl_getObjectUserDownList({
          key: this.baseInForm.objectStatus || "",
          name: name || "",
          pageStart: 1,
          pageTotal: 200,
        })
        .then((res) => {
          this.CustomerListsYF = res.data.result.data || [];
        });
    },
    changeobjectName(e) {
      if (!e) {
        this.getObjectUserDownListYf();
      } else {
        this.CustomerListsYF.forEach((item) => {
          if (item.name === e) {
            this.baseInForm.objectNumber = item.number;
          }
        });
      }
    },
    // 获取字典数据（开票项目=invoice_project）
    GetDictionaries(param) {
      return this.$API
        .getConfDictValDownList({ dictType: param })
        .then((res) => {
          if (res.data.status === "success") {
            let result = res.data.result || [];
            // 开票项目
            if (param === "invoice_project") {
              this.invoiceProjects = result;
            }
            // 发票类型
            if (param === "fa_piao_type") {
              this.invoiceTypes = result;
              let curs1 = result.filter((item) => item.type == "fa_piao_type");
              this.invoiceTypeConfDictId =
                (curs1.length && curs1[0].confDictId) || "";
            }
            // 发票种类
            if (param === "invoice_type") {
              this.invoice_type_list = result;
            }
            if (param == "object_status") {
              // 获取结算对象类型
              this.objectStatusList = result;
            }
          }
        });
    },

    // // 获取发票列表
    // GetInvoiceList(param) {
    //   this.$API.InvoiceDetail({ invoiceId: param }).then((res) => {
    //     if (res.data.status === "success") {
    //       let result = res.data.result || {};
    //       this.baseInForm = result;
    //     }
    //   });
    // },

    // 获取对账单列表
    GetStatementList(id) {
      let param = {};
      if (id) {
        param.number = id;
      } else {
        param.pageStart_dia = this.pageStart;
        param.pageTotal_dia = this.pageTotal;
      }
      this.$API.StatementList(param).then((res) => {
        if (res.data.status === "success") {
          let result = res.data.result?.data || [];
          if (id && result.length > 0) {
            this.wirteInfo(result[0]);
            return false;
          }
          this.tableConfig_dia.tableData = result;
          this.pageCount_dia = res.data.result.pageCount;
        }
      });
    },
    // 表格内按钮的回调事件
    rowCallback(data, name) {
      this[name](data);
      this.baseInForm.objectStatus = data.objectStatus;
      this.baseInForm.objectName = data.objectName;
      this.baseInForm.objectStatusConfDictId = data.objectStatusConfDictId;
      this.baseInForm.objectNumber = data.objectNumber;
      console.log(this.baseInForm);
      this.getObjectUserDownListYf();
    },

    // 打开对账单号列表
    choiceOrder() {
      this.GetStatementList();
      this.isShowDialog = true;
    },

    //  选择对账单账号
    checkdata(DATA) {
      this.wirteInfo(DATA);
      this.pageStart_dia = 1;
      this.pageTotal_dia = 20;
      this.pageCount_dia = 0;
      this.pageStart = 1;
      this.pageTotal = 20;
      this.isShowDialog = false;
    },

    wirteInfo(DATA) {
      this.baseInForm.documentNumber = DATA.number;
      this.baseInForm.hadInvoiceAmount = DATA.invoiceAmount || 0;
      this.baseInForm.needInvoiceAmount = DATA.noInvoiceAmount || 0;
      this.baseInForm.noInvoiceAmount = DATA.noInvoiceAmount || 0;
      this.baseInForm.amount = DATA.settlementAmount || 0;
    },
    //  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn() {
      this.isShowDialog = false;
    },
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia() {
      this.isShowDialog = false;
    },
    //  弹窗确认保存事件
    diaConfirmBtn() {
      this.isShowDialog = false;
    },
    handleSelectionChange_dia() {},
    // 分页的方法
    handleSizeChange(val) {
      this.pageTotal = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.pageStart = val;
      this.getData();
    },
    // 开票
    createInvoice() {
      // 正常提交

      let { invoiceProjectConfDictId } = this.baseInForm;
      let curs1 = this.invoiceTypes.filter(
        (item) => item.confDictId == invoiceProjectConfDictId
      );
      this.baseInForm.invoiceProject = (curs1.length && curs1[0].val) || "";
      this.projectList.forEach((element, index) => {
        this.invoiceProjects.forEach((item) => {
          if (element.invoiceProjectConfDictId == item.confDictId) {
            element.invoiceProject = item.val;
          }
        });
      });

      let param = {
        saleHeaderInfo: this.saleHeaderInfo,
        projectList: this.projectList,
        headerInfo: this.headerInfo,
        baseInfo: this.baseInForm,
      };
      if (this.keyType == 1) {
        this.$API.invoiceaddInvoice(param).then((res) => {
          if (res.data.status === "success") {
            this.$message.success(res.data.message);
            this.$TOOLS.closePage();
            this.$router.push({
              path: "/FM/InvoicesControlRX",
              query: {
                isreload: "isreload",
              },
            });
          }
        });
      } else if (this.keyType == 2) {
        delete param.baseInfo.invoiceId;
        this.$API.invoiceaddInvoice(param).then((res) => {
          if (res.data.status === "success") {
            this.$message.success(res.data.message);
            this.$TOOLS.closePage();
            this.$router.push({
              path: "/FM/InvoicesControlRX",
              query: {
                isreload: "isreload",
              },
            });
          }
        });
      } else if (this.keyType == 3) {
        param.submitType = "SAVE";
        this.$API.invoiceinvoiceSure(param).then((res) => {
          if (res.data.status === "success") {
            this.$message.success(res.data.message);
            this.$TOOLS.closePage();
            this.$router.push({
              path: "/FM/InvoicesControlRX",
              query: {
                isreload: "isreload",
              },
            });
          }
        });
      } else if (this.keyType == 4) {
        param.submitType = "SURE";
        this.$API.invoiceinvoiceSure(param).then((res) => {
          if (res.data.status === "success") {
            this.$message.success(res.data.message);
            this.$TOOLS.closePage();
            this.$router.push({
              path: "/FM/InvoicesControlRX",
              query: {
                isreload: "isreload",
              },
            });
          }
        });
      }
    },
    // 重置
    resetFields() {
      this.$refs["baseInForm"].resetFields();
    },
  },
};
</script>
  <style scoped lang="less">
@borderColor: #cccccc;
.InvoicesAddRX {
  .h3title {
    background-color: #f2f2f2;
    padding: 10px;
    border-bottom: 1px solid @borderColor;
    font-weight: bold;
    margin-bottom: 20px;
  }
  .saveBtn {
    padding: 10px 20px;
  }
  .formPanel {
    padding: 10px 20px;
    margin: 12px 0;
    background: rgba(0, 0, 0, 0.05);
    /deep/ .el-form-item {
      background: #fff !important;
    }
  }
  /deep/.el-input-group__append {
    line-height: 31px;
  }
  .multipleSelect {
    display: flex;

    /deep/ .el-select {
      flex: 1;
    }
  }
}
.iconList {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  //   text-align: center;

  .iconSize {
    font-size: 26px;
    cursor: pointer;
  }

  .tbBtns {
    padding: 5px 10px;
    margin: 0;
    border: 1px solid #333;
  }
}
</style>
  
  